import { BiLogOutCircle, BiMedal, BiEnvelope, BiSolidCoupon } from "react-icons/bi";
import { BiCog, BiSolidTruck, BiDollarCircle } from "react-icons/bi";
import { NavLink, useNavigate, useParams, } from 'react-router-dom';
import { hoverSidebar } from '../../redux/slices/sidebarslice';
import { AuthLogout } from '../../redux/slices/auth.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Images from '../../assets/js/images';
import { FiUsers } from "react-icons/fi";
import { FaCar } from "react-icons/fa";
import { Nav } from 'react-bootstrap';
import { Fragment } from 'react';

const Sidebar = ({ user }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { type, id, page } = useParams()
  const path = window.location.pathname;
  const { hover } = useSelector(state => state.SidebarSlice);

  const handleLogout = (id) => {
    dispatch(AuthLogout({ id: id, navigate }));
    dispatch({ type: "LOGOUT", payload: "" });
  }

  const checkUrl = (npath) => {
    if (path.startsWith(npath)) {
      return 'mm-active';
    } else if (path === npath) {
      return 'mm-active';
    } else {
      return '';
    }
  }

  return (
    <Fragment>
      <div className="sidebar-wrapper" data-simplebar="true" onMouseEnter={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }} onMouseLeave={() => {
        dispatch(hoverSidebar(hover ? false : true))
      }}>
        <div className="sidebar-header justify-content-center">
          <div>
            <img src={Images?.AdminLogo} className="logo-icon" alt="logo icon" />
          </div>
        </div>
        <Nav as="ul" className="metismenu" id="menu">
          <Nav.Item as="li">
            <NavLink to={`${user?.role === 'partner' ? '/partner/dashboard' : user?.role === 'insurance' ? '/insurance' : '/admin/dashboard'}`} className={({ isActive, isPending, }) =>
              isPending ? "pending" : isActive ? "mm-active" : ""
            }>
              <div className="parent-icon">
                <svg width="1em" height="1em" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.25 8C2.25 8.41423 2.58579 8.75 3 8.75H9C9.41423 8.75 9.75 8.41423 9.75 8V3.5C9.75 3.08579 9.41423 2.75 9 2.75H3C2.58579 2.75 2.25 3.08579 2.25 3.5V8ZM8.25 15.5C8.25 15.9142 8.58577 16.25 9 16.25H15C15.4142 16.25 15.75 15.9142 15.75 15.5V11C15.75 10.5858 15.4142 10.25 15 10.25H9C8.58577 10.25 8.25 10.5858 8.25 11V15.5ZM9.75 11.75H14.25V14.75H9.75V11.75ZM2.25 15.5C2.25 15.9142 2.58579 16.25 3 16.25H6C6.41422 16.25 6.75 15.9142 6.75 15.5V11C6.75 10.5858 6.41422 10.25 6 10.25H3C2.58579 10.25 2.25 10.5858 2.25 11V15.5ZM3.75 14.75V11.75H5.25V14.75H3.75ZM3.75 7.25V4.25H8.25V7.25H3.75ZM15 8.75C15.4142 8.75 15.75 8.41423 15.75 8V3.5C15.75 3.08579 15.4142 2.75 15 2.75H12C11.5858 2.75 11.25 3.08579 11.25 3.5V8C11.25 8.41423 11.5858 8.75 12 8.75H15ZM14.25 7.25H12.75V4.25H14.25V7.25Z" fill="currentColor" />
                </svg>
              </div>
              <div className="menu-title">{t('dashboard')}</div>
            </NavLink>
          </Nav.Item>

          {user?.role === 'superadmin' &&
            <>
              <Nav.Item as="li">
                <NavLink to="/admin/users/list/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/users/list/${type}`)}`
                }>
                  <div className="parent-icon"><i><FiUsers /></i>
                  </div>
                  <div className="menu-title">{t('users')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/ride/list/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/ride/${type}/${id}`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-calendar'></i>
                  </div>
                  <div className="menu-title">{t('bookings')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/insurance/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/insurance/view/${id}`)}`
                }>
                  <div className="parent-icon">
                    <svg width="24" height="24" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.10734 3.47917C3.72331 1.8632 6.29803 1.79033 8.00045 3.26057C9.70179 1.79033 12.2765 1.8632 13.8925 3.47917C15.5055 5.09224 15.581 7.66067 14.1189 9.36313L8.94272 14.5572C8.44565 15.0542 7.65385 15.0768 7.13005 14.6249L7.05712 14.5572L1.88086 9.36313C0.418773 7.66067 0.494267 5.09224 2.10734 3.47917ZM3.05015 4.42197C1.91205 5.56007 1.87953 7.38507 2.9526 8.56247L3.05015 8.6646L7.99992 13.6143L11.535 10.0783L9.17839 7.7218L8.47132 8.42893C7.69025 9.20993 6.42392 9.20993 5.64287 8.42893C4.86183 7.64787 4.86183 6.38153 5.64287 5.60049L7.04365 4.19882C5.90187 3.28475 4.24709 3.32662 3.15232 4.32442L3.05015 4.42197ZM8.70699 6.30759C8.96732 6.04724 9.38945 6.04724 9.64979 6.30759L12.4778 9.13553L12.9497 8.6646C14.1212 7.49307 14.1212 5.59355 12.9497 4.42197C11.8115 3.28387 9.98652 3.25136 8.80919 4.32442L8.70699 4.42197L6.58568 6.54329C6.34393 6.78505 6.32666 7.16628 6.53388 7.42793L6.58568 7.48613C6.82745 7.72787 7.20865 7.74513 7.47032 7.53793L7.52852 7.48613L8.70699 6.30759Z" fill="currentColor" />
                    </svg>
                  </div>
                  <div className="menu-title">{t('insurance_policy')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/insurance-list" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl('/admin/insurance/edit')}`
                }>
                  <div className="parent-icon"><i className='bx bx-buildings'></i>
                  </div>
                  <div className="menu-title">{t('insurance_company')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/partner-list" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/partner`)}`
                }>
                  <div className="parent-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.435 8.01224L9.77802 6.34924C9.61935 6.19058 9.54002 6.00391 9.54002 5.78924C9.54002 5.57458 9.62102 5.38591 9.78302 5.22324L11.44 3.56124C11.598 3.40258 11.7854 3.32324 12.002 3.32324C12.2187 3.32324 12.4087 3.40424 12.572 3.56624L14.228 5.22824C14.3867 5.38691 14.466 5.57358 14.466 5.78824C14.466 6.00291 14.385 6.19158 14.223 6.35424L12.566 8.01624C12.408 8.17491 12.2207 8.25424 12.004 8.25424C11.7874 8.25424 11.5974 8.17358 11.434 8.01224M2.82802 19.3852C2.59935 19.3852 2.40769 19.3079 2.25302 19.1532C2.09769 18.9979 2.02002 18.8059 2.02002 18.5772V15.8842C2.02002 15.4842 2.15202 15.1409 2.41602 14.8542C2.67935 14.5669 3.00269 14.4102 3.38602 14.3842H6.27602C6.54535 14.3842 6.80102 14.4486 7.04302 14.5772C7.28569 14.7052 7.48569 14.8919 7.64302 15.1372C8.15235 15.8506 8.78669 16.4039 9.54602 16.7972C10.306 17.1892 11.1244 17.3852 12.001 17.3852C12.8837 17.3852 13.7074 17.1889 14.472 16.7962C15.2374 16.4042 15.8727 15.8509 16.378 15.1362C16.5434 14.8916 16.745 14.7052 16.983 14.5772C17.2204 14.4492 17.468 14.3852 17.726 14.3852H20.616C21.0034 14.4106 21.331 14.5669 21.599 14.8542C21.867 15.1409 22.001 15.4842 22.001 15.8842V18.5772C22.001 18.8059 21.9237 18.9979 21.769 19.1532C21.6137 19.3079 21.4217 19.3852 21.193 19.3852H16.809C16.5797 19.3852 16.3877 19.3079 16.233 19.1532C16.0777 18.9979 16 18.8059 16 18.5772V16.9562C15.442 17.4116 14.821 17.7636 14.137 18.0122C13.453 18.2609 12.739 18.3852 11.995 18.3852C11.2684 18.3852 10.5684 18.2626 9.89502 18.0172C9.22035 17.7726 8.59502 17.4232 8.01902 16.9692V18.5772C8.01902 18.8059 7.94169 18.9979 7.78702 19.1532C7.63235 19.3086 7.44035 19.3859 7.21102 19.3852H2.82802ZM4.58002 12.6152C3.89935 12.6152 3.31202 12.3686 2.81802 11.8752C2.32469 11.3819 2.07802 10.7946 2.07802 10.1132C2.07802 9.41858 2.32469 8.82858 2.81802 8.34324C3.31135 7.85858 3.89869 7.61624 4.58002 7.61624C5.27469 7.61624 5.86469 7.85858 6.35002 8.34324C6.83535 8.82858 7.07802 9.41858 7.07802 10.1132C7.07802 10.7946 6.83535 11.3819 6.35002 11.8752C5.86469 12.3686 5.27469 12.6152 4.58002 12.6152ZM19.426 12.6152C18.7454 12.6152 18.1584 12.3686 17.665 11.8752C17.171 11.3819 16.924 10.7946 16.924 10.1132C16.924 9.41858 17.1707 8.82858 17.664 8.34324C18.1574 7.85858 18.7447 7.61624 19.426 7.61624C20.1207 7.61624 20.7107 7.85858 21.196 8.34324C21.6814 8.82858 21.924 9.41858 21.924 10.1132C21.924 10.7946 21.6814 11.3819 21.196 11.8752C20.7107 12.3686 20.1207 12.6152 19.426 12.6152Z" fill="currentColor" />
                    </svg>
                  </div>
                  <div className="menu-title">{t('partners')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/earnings/total_earning" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/earnings`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-dashboard'></i>
                  </div>
                  <div className="menu-title">{t('earnings')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/profile/verifications/pending" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/profile/verifications/${type}`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-badge-check'></i>
                  </div>
                  <div className="menu-title">{t('profile_verifications')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/withdrawl/approved" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/withdrawl/${type}`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-download'></i>
                  </div>
                  <div className="menu-title">{t('withdrawal_request')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/driver/trips" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl('/admin/driver/trip')}`
                }>
                  <div className="parent-icon"><FaCar />
                  </div>
                  <div className="menu-title">{t('driver_trips')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/top/ranking/rider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/top/ranking/${type}`)}`
                }>
                  <div className="parent-icon"><i><BiMedal /></i>
                  </div>
                  <div className="menu-title">{t('top_rankings')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/coupons" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl('admin/coupons')}`
                }>
                  <div className="parent-icon"><i><BiSolidCoupon /></i>
                  </div>
                  <div className="menu-title">{t('coupons')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/charges" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl('  admin/charges')}`
                }>
                  <div className="parent-icon"><i><BiDollarCircle /></i>
                  </div>
                  <div className="menu-title">{t('charges')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/emails/user" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/emails/${type}`)}`
                }>
                  <div className="parent-icon"><i><BiEnvelope /></i>
                  </div>
                  <div className="menu-title">{t('email')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/roles" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/role`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-user-circle'></i>
                  </div>
                  <div className="menu-title">{t('role_management')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/admin-list" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/edit/${id}`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-user'></i>
                  </div>
                  <div className="menu-title">{t('admins')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/services" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/services`) || checkUrl(`/admin/service`)}`
                }>
                  <div className="parent-icon"><BiCog />
                  </div>
                  <div className="menu-title">{t('mechanic_service')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/vechile-types" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/vechile-types`) || checkUrl(`/admin/vechile-types`)}`
                }>
                  <div className="parent-icon"><BiSolidTruck />
                  </div>
                  <div className="menu-title">{t('service_class')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/payment/history" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/payment/history`) || checkUrl(`/admin/payment/history/${page}`)}`
                }>
                  <div className="parent-icon"><i className='bx bxs-badge-dollar'></i>
                  </div>
                  <div className="menu-title">{t('payment_history')}</div>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <NavLink to="/admin/slider" className={({ isActive, isPending }) =>
                  `${isPending ? "pending" : isActive ? "mm-active" : ""} ${checkUrl(`/admin/slider`) || checkUrl(`/admin/slider`)}`
                }>
                  <div className="parent-icon"><i className='bx bx-slider-alt'></i>
                  </div>
                  <div className="menu-title">{t('slider')}</div>
                </NavLink>
              </Nav.Item>
            </>
          }
          <Nav.Item as="li">
            <NavLink type="button" onClick={() => { handleLogout(user?._id) }}>
              <div className="parent-icon"><i><BiLogOutCircle style={{ transform: 'rotate(180deg)' }} /></i>
              </div>
              <div className="menu-title">{t('logout')}</div>
            </NavLink>
          </Nav.Item>
        </Nav>
      </div>
    </Fragment >
  )
}

export default Sidebar;